import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { node, oneOf } from 'prop-types';
import { Container } from './toolbar.styles';
import ToolbarItem from './toolbar-item';
import ToolbarToggle from './toolbar-toggle';

const Toolbar = _ref => {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    count: React.Children.count(children),
    "data-testid": "toolbar"
  }, props), children);
};

process.env.NODE_ENV !== "production" ? Toolbar.propTypes = {
  children: node,
  variant: oneOf(['primary', 'secondary', 'light', 'transparent']),
  scale: oneOf(['small', 'medium', 'large'])
} : void 0;
Toolbar.defaultProps = {
  children: null,
  variant: 'transparent',
  scale: 'medium'
};
Toolbar.Item = ToolbarItem;
Toolbar.Toggle = ToolbarToggle;
export default Toolbar;